import React from 'react';

function About() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">About ForgePass</h1>
      <p>ForgePass is a decentralized certification platform built for modern, verifiable credentials.</p>
    </div>
  );
}

export default About;
